<template>
    <div id="noData">
        <img src="@/assets/images/template/bg_pic1.png"/>
        <span>{{$t("trade.noData.noLogin")}}</span>
        <a @click="goLogin">{{$t("login.goLogin")}}</a>
    </div>
</template>

<script>
    export default {
        name: "NoLogin",
        methods:{
            goLogin(){
                this.$router.push({path: '/login'})
            }
        }
    }
</script>
